import axios from 'axios';
import { BASE_URL } from '../../Constants/constants';

// Helper function to get authorization config
const getAuthConfig = () => {
    const token = localStorage.getItem('accessToken');
    if (!token) {
        throw new Error('Authentication token is missing.');
    }
    return {
        headers: { Authorization: `Bearer ${token}` },
    };
};

export const assetService = {
    // Get all assets
    getAssets: async () => {
        try {
            const config = getAuthConfig();
            const response = await axios.get(`${BASE_URL}/assets/`, config);
            return response.data;
        } catch (error) {
            console.error('Error fetching assets:', error);
            throw error;
        }
    },

    // Get asset by ID
    getAsset: async (assetId) => {
        try {
            const config = getAuthConfig();
            const response = await axios.get(`${BASE_URL}/assets/${assetId}`, config);
            return response.data;
        } catch (error) {
            console.error('Error fetching asset:', error);
            throw error;
        }
    },

    // Create new asset
    createAsset: async (assetData) => {
        try {
            const config = getAuthConfig();
            const response = await axios.post(`${BASE_URL}/assets/`, assetData, config);
            return response.data;
        } catch (error) {
            console.error('Error creating asset:', error);
            throw error;
        }
    },

    // Update asset
    updateAsset: async (assetId, updateData) => {
        try {
            const config = getAuthConfig();
            const response = await axios.put(`${BASE_URL}/assets/${assetId}`, updateData, config);
            return response.data;
        } catch (error) {
            console.error('Error updating asset:', error);
            throw error;
        }
    },

    // Delete asset
    deleteAsset: async (assetId) => {
        try {
            const config = getAuthConfig();
            const response = await axios.delete(`${BASE_URL}/assets/${assetId}`, config);
            return response.data;
        } catch (error) {
            console.error('Error deleting asset:', error);
            throw error;
        }
    },

    // Bulk create assets
    bulkCreateAssets: async (assetsArray) => {
        try {
            const config = getAuthConfig();
            const response = await axios.post(`${BASE_URL}/assets/bulk`, assetsArray, config);
            return response.data;
        } catch (error) {
            console.error('Error bulk creating assets:', error);
            throw error;
        }
    },

    // Get assets by custodian
    getAssetsByCustodian: async (custodianEmail) => {
        try {
            const config = getAuthConfig();
            const response = await axios.get(`${BASE_URL}/assets/custodian/${custodianEmail}`, config);
            return response.data;
        } catch (error) {
            console.error('Error fetching assets by custodian:', error);
            throw error;
        }
    },

    // Get models by brand
    getModelsByBrand: async (brand) => {
        try {
            const config = getAuthConfig();
            const response = await axios.get(`${BASE_URL}/assets/models/${brand}`, config);
            return response.data;
        } catch (error) {
            console.error('Error fetching models by brand:', error);
            throw error;
        }
    },

    // Get equipment by brand and model
    getEquipmentByModel: async (brand, model) => {
        try {
            const config = getAuthConfig();
            const response = await axios.get(`${BASE_URL}/assets/equipment/${brand}/${model}`, config);
            return response.data;
        } catch (error) {
            console.error('Error fetching equipment by model:', error);
            throw error;
        }
    },

    // Assign asset to user
    assignAssetToUser: async (assignmentData) => {
        try {
            const config = getAuthConfig();
            const response = await axios.post(`${BASE_URL}/equipment/assign-from-asset`, assignmentData, config);
            return response.data;
        } catch (error) {
            console.error('Error assigning asset to user:', error);
            throw error;
        }
    },

    // Get available assets
    getAvailableAssets: async () => {
        try {
            const config = getAuthConfig();
            const response = await axios.get(`${BASE_URL}/assets/available/`, config);
            return response.data;
        } catch (error) {
            console.error('Error fetching available assets:', error);
            throw error;
        }
    },

    // Assign asset (alternative method using asset endpoint)
    assignAsset: async (assetId, assignmentData) => {
        try {
            const config = getAuthConfig();
            const response = await axios.put(`${BASE_URL}/assets/${assetId}/assign`, assignmentData, config);
            return response.data;
        } catch (error) {
            console.error('Error assigning asset:', error);
            throw error;
        }
    },

    // Unassign asset
    unassignAsset: async (assetId) => {
        try {
            const config = getAuthConfig();
            const response = await axios.put(`${BASE_URL}/assets/${assetId}/unassign`, {}, config);
            return response.data;
        } catch (error) {
            console.error('Error unassigning asset:', error);
            throw error;
        }
    }
};